import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import generateId from './generateId';
import { updateHashProps, rewriteUserId } from '../general';
import { addDatasToSave, loadDbModel } from './workBackendSlice';
import { saveAllData, saveData, deleteData, SignUpPayload } from './dataBackend';

export type RelationAlbumImageDb = {
  albumId: string;
  imageId: string;
  order: number;
}
const initial: RelationAlbumImageDb = {
  albumId: '',
  imageId: '',
  order: 0
};

export type RelationAlbumImageDbHashType = {
  [key in string]: RelationAlbumImageDb;
}

export type RelationAlbumImageAddPayload = {
  id?: string;
} & RelationAlbumImageDb;
export type RelationAlbumImageUpdatePayload = {
  id: string;
} & { [P in keyof RelationAlbumImageDb]?: RelationAlbumImageDb[P] };

export type RelationAlbumImageDbState = {
  relationAlbumImages: RelationAlbumImageDbHashType;
}

export const generateRelationAlbumImageId = (): string => generateId('rai');
let initialState: RelationAlbumImageDbState = { relationAlbumImages: {} };
const key = 'relationAlbumImages';

const relationAlbumImageDbSlice = createSlice({
  name: 'relationAlbumImageDb',
  initialState,
  reducers: {
    initializeRelationAlbumImages(state: RelationAlbumImageDbState) {
      state.relationAlbumImages = {};
    },
    addRelationAlbumImage(state: RelationAlbumImageDbState, action: PayloadAction<RelationAlbumImageAddPayload>) {
      let { id, ...obj } = action.payload;
      if (!id) id = generateRelationAlbumImageId();
      state.relationAlbumImages[id] = obj;
      saveData(key, id, obj);
    },
    updateRelationAlbumImage(state: RelationAlbumImageDbState, action: PayloadAction<RelationAlbumImageUpdatePayload>) {
      const { id, ...obj } = action.payload;
      if (state.relationAlbumImages[id] === undefined) {
        console.log(`*** RelationAlbumImage not found: ${id}`);
      } else {
        const newData = { ...state.relationAlbumImages[id], ...obj };
        state.relationAlbumImages[id] = newData;
        saveData(key, id, newData);
      }
    },
    deleteRelationAlbumImage(state: RelationAlbumImageDbState, action: PayloadAction<RelationAlbumImageUpdatePayload>) {
      const id = action.payload.id;
      delete state.relationAlbumImages[id];
      deleteData(key, id);
    },
    saveRelationAlbumImages(state: RelationAlbumImageDbState) {
      saveAllData(key, state.relationAlbumImages);
    },
    signUpRelationAlbumImages(state: RelationAlbumImageDbState, action: PayloadAction<SignUpPayload>) {
      const values = rewriteUserId(state.relationAlbumImages, action.payload);
      addDatasToSave(key, values);
    }
  },
  extraReducers: (builder) => {
    builder.addCase(loadDbModel(key).fulfilled, (state: RelationAlbumImageDbState, action) => {
      const values = action.payload;
      const [changed, updatedValues] = updateHashProps(initial, values);
      state.relationAlbumImages = updatedValues;
      if (changed) saveAllData(key, state.relationAlbumImages);
    })
  }
})

export const { initializeRelationAlbumImages, addRelationAlbumImage, updateRelationAlbumImage, deleteRelationAlbumImage, saveRelationAlbumImages, signUpRelationAlbumImages } = relationAlbumImageDbSlice.actions;
export default relationAlbumImageDbSlice.reducer;
